export default __webpack_public_path__ + "static/media/icon_nav_close.0dc3e53e.svg";